import request from "./client";

export const getById = async ({ id }) => {
  const resp = await request.get(`/v1/delivery_note_templates/${id}`);
  return { data: resp.body };
};
export const getSome = async ({ q = "", limit = 10, offset = 0 }) => {
  const query = new URLSearchParams({
    limit,
    offset,
    ...(q && { q }),
  }).toString();
  try {
    const resp = await request.get(`/v1/delivery_note_templates?${query}`);
    const body = resp.body;
    return { total: body.meta.total, data: body.results, error: null };
  } catch (e) {
    if (!e.response) {
      return { total: 0, data: [], error: e };
    }
    return { total: 0, data: [], error: e.response.body };
  }
};

export const createOne = async ({
  name,
  item_ids,
  documentation_schema,
  documentation,
}) => {
  try {
    const resp = await request
      .post("/v1/delivery_note_templates")
      .send({ name, item_ids, documentation_schema, documentation });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const updateOne = async ({
  id,
  name,
  item_ids,
  documentation_schema,
  documentation,
}) => {
  try {
    const resp = await request
      .put(`/v1/delivery_note_templates/${id}`)
      .send({ name, item_ids, documentation_schema, documentation });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const deleteOne = async ({ id }) => {
  try {
    await request.delete(`/v1/delivery_note_templates/${id}`);
    return { error: null };
  } catch (e) {
    if (!e.response) {
      return { error: e };
    }
    return { error: e.response.body };
  }
};
